import { TeamOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId, getUserData } from "../../Redux/UserSlice";
import { backendApi, callPlayBot, LiveCallApi } from "../../services/service";
import LoaderComp from "../../LoaderComp";

import "../Verification/VerificationPage.css";
import "./PersonalDetails.css";
const PersonalDetails = ({ setPage, languageContent, userData }) => {
  const user = useSelector(getUserData);
  const call_id = useSelector(getCallId);
  const dispatch = useDispatch();
  const [showButtons, setShowButtons] = useState(false);
  const [hdfcCheckbox, setHdfcCheckbox] = useState(false)
  const [checkboxHand, setCheckboxHand] = useState(false)
  const [liveCallResponse, setLiveCallResponse] = useState(false)


  let nudge30SecondTimer = useRef(null)
  let nudge60SecondTimer = useRef(null)
  const tncContent = useRef(null)

  const template_personal_detail = async () => {
    await callPlayBot(call_id, "personal_detail")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          setShowButtons(true);
          if(userData.flow_type && userData.flow_type.toLowerCase() === "hdfc"){
            setPage('callDisconnected')
            
          }
        }
        setLiveCallResponse(true)
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };
  const template_nudge = () => {
    callPlayBot(call_id, "no_input_nudge")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  }
  const clearNudgeTimers = () => {
    clearTimeout(nudge30SecondTimer)
    clearTimeout(nudge60SecondTimer)
  }
  useEffect(() => {
    window.scrollTo(0, 0);

    nudge30SecondTimer = setTimeout(() => template_nudge(), 36000);
    nudge60SecondTimer = setTimeout(() => template_nudge(), 66000);

    submitApi("personalDetail", "open");
    template_personal_detail();
    const id = setTimeout(() => {
      setShowButtons(true);
    }, 6000);
    return () => {
      clearTimeout(id);
      clearNudgeTimers();
    }
  }, []);

  const handleAgreePersonalDetails = async () => {
    clearNudgeTimers();
    if (user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc') {
      if (hdfcCheckbox) {
        await backendApi(call_id, "personal_page", "agree").then((res) => {
          if (res.data) setPage("policyDetails");
        })
          .catch((e) => {
            dispatch(e.message);
            setPage("sorryPage");
          });
      } else {
        setCheckboxHand(true)
        tncContent.current?.scrollIntoView({ behavior: "smooth" })
        await callPlayBot(call_id, "terms_and_conditions")
          .then((res) => {
            if (res.data === 200) {
              console.log("okay play api");
            }
          })
          .catch((e) => console.log(e.message));
      }
    } else {
      await backendApi(call_id, "personal_page", "agree").then((res) => {
        if (res.data) setPage("policyDetails");
      })
        .catch((e) => {
          dispatch(e.message);
          setPage("sorryPage");
        });
    }
  };
  const handleDisagreePersonalDetails = async () => {
    clearNudgeTimers();
    await backendApi(call_id, "personal_page", "disagree")
      .then((res) => {
        if (res.data) {
          setPage("personalDetailDisagree");
        }
      })
      .catch((e) => {
        dispatch(e.message);
        setPage("sorryPage");
      });
  };
  return (
    liveCallResponse ? 
    <>
      <div className="heading">
        <img
          src="./video-call.png"
          style={{ height: "35px", width: "35px", marginRight: "0.4rem" }}
          alt="Immigration"
        />
        <p>{languageContent.personal_detail_page.personal_title}</p>
      </div>
      <hr></hr>
      <table className="table">
        <tbody>
          <tr>
            <td>
              <Icon icon="la:file-alt-solid" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.application_number}
              </span>
              <br />
              <span className="table-col-data">{user.application_number}</span>
            </td>
            <td>
              <Icon icon="bx:bxs-user" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.policy_number}
              </span>
              <br />
              <span className="table-col-data">{user.policy_owner_name}</span>
            </td>
          </tr>
          <tr>
            <td>
              <Icon icon="bx:bx-calendar" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.owner_DOB}
              </span>
              <br />
              <span className="table-col-data">
                {moment(user.policy_owner_dob).format("DD/MM/YYYY")}
              </span>
            </td>
            <td>
              <TeamOutlined />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.life_insured}
              </span>
              <br />
              <span className="table-col-data">{user.insured_name}</span>
            </td>
          </tr>
          {user?.flow_type && user?.flow_type.toLowerCase() === "hdfc" &&
            <tr>
              <td>
                <Icon
                  icon="bx:bxs-briefcase"
                  inline={true}
                  color="#505050"
                  style={{ marginRight: "0.25rem" }}
                />
                <span className="table-col-heading">
                  {languageContent.personal_detail_page.occupation}
                </span>
                <br />
                <span className="table-col-data">
                  {user.occupation}
                </span>
              </td>
              <td>
                <img
                  src="./rupee.png"
                  alt="Rupee"
                  height="20px"
                  width="20px"
                  style={{ marginRight: "4px" }}
                />
                <span className="table-col-heading">
                  {languageContent.personal_detail_page.income}
                </span>
                <br />
                <span className="table-col-data">INR {user.income}</span>
              </td>
            </tr>
          }
          <tr>
            <td>
              <Icon icon="bx:bxs-calendar-check" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.insured_DOB}
              </span>
              <br />
              <span className="table-col-data">
                {moment(user.insured_dob).format("DD/MM/YYYY")}
              </span>
            </td>
          </tr>


        </tbody>
      </table>
      <hr></hr>
      <table className="table">
        <tbody>
          <tr>
            <td>
              <Icon icon="bx:bx-mail-send" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.email}
              </span>
              <br />
              <span className="table-col-data">{user.email}</span>
            </td>
            <td>
              <Icon icon="bx:bxs-phone" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.contact_number}
              </span>
              <br />
              <span className="table-col-data">{user.msisdn}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <hr></hr>
      <table className="table">
        <tbody>
          <tr>
            <td>
              <Icon icon="bx:bxs-map-pin" inline={true} />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.address}
              </span>
              <br />
              <span className="table-col-data">{user.address}</span>
            </td>
          </tr>
          <tr>
            <td>
              <img
                src="./india.png"
                alt="No image"
                height="20px"
                width="20px"
                style={{ marginRight: "4px" }}
              />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.city_state}
              </span>
              <br />
              <span className="table-col-data">
                {user.city}/{user.state}
              </span>
            </td>
            <td>
              <img
                src="./mail.png"
                alt="No image"
                height="20px"
                width="20px"
                style={{ marginRight: "4px" }}
              />
              <span className="table-col-heading">
                {languageContent.personal_detail_page.pinCode}
              </span>
              <br />
              <span className="table-col-data">{user.pincode}</span>
            </td>
          </tr>
        </tbody>
      </table>
      {user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc' ? <>
        <div className="form-check" style={{ marginLeft: '2rem', marginRight: '2rem', fontSize: '0.9rem' }}>
          <input style={{ height: '1rem', width: '2rem' }} type="checkbox" checked={hdfcCheckbox} id="flexCheckChecked" onChange={() => {
            clearNudgeTimers();
            setHdfcCheckbox(!hdfcCheckbox)
          }} />
          {
            !hdfcCheckbox && checkboxHand ? 
            // <img
            //   src="./hand3.png"
            //   className="tncHand"
            //   alt=""
            // /> 
            null
            : null
          }

          <label ref={tncContent} htmlFor="flexCheckChecked" style={{ marginLeft: '0.5rem' }}>
            {languageContent.personal_detail_page.hdfcCheckBox}
          </label>
        </div>
      </> : null}
      {showButtons && (
        <>
          <div className="floatingButton">
            <p> {languageContent.personal_detail_page.info}</p>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button
                className="backButton"
                onClick={handleDisagreePersonalDetails}
              >
                {languageContent.buttons.disagree}
              </button>
              <button className="myButton" onClick={handleAgreePersonalDetails} >
                {languageContent.buttons.agree}
              </button>
            </div>
            {/* {(user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc') ? null : (<img
              src="./hand.png"
              className="submitHandIcon"
              alt=""
              style={{ height: "3rem", width: "3rem" }}
            />)} */}

          </div>
        </>
      )}
    </>
    :
    <LoaderComp />
  );
};

export default PersonalDetails;
